module.exports = __webpack_public_path__ + "static/6305-woodrose-43-697a3248603f409931dfd4e898173ef1.jpg";